import {get} from "@/context/context";
import {FileRepository} from "@/repositories/FileRepository";
import {FileImageResponse} from "@/models/File/FileImageResponse";
import {FileAudioResponse} from "@/models/File/FileAudioResponse";
import {FileVideoResponse} from "@/models/File/FileVideoResponse";
import {RequestConfig} from "@/models/RequestConfig";
import {FileRequest} from "@/models/File/FileRequest";

export class FileService {

    public fileRepository: FileRepository = get('fileRepository');

    public async uploadImage(payload: FileRequest, config?: RequestConfig): Promise<FileImageResponse> {
        return await this.fileRepository.uploadImage(payload, config);
    }

    public async uploadAvatar(payload: FileRequest, config?: RequestConfig): Promise<FileImageResponse> {
        return await this.fileRepository.uploadAvatar(payload, config);
    }

    public async uploadVideo(payload: FileRequest, config?: RequestConfig): Promise<FileVideoResponse> {
        return await this.fileRepository.uploadVideo(payload, config);
    }

    public async uploadAudio(payload: FileRequest, config?: RequestConfig): Promise<FileAudioResponse> {
        return await this.fileRepository.uploadAudio(payload, config);
    }

    public async uploadMultiAudio(payload: Array<File>, config?: RequestConfig): Promise<any> {
        return await this.fileRepository.uploadMultiAudio(payload, config);
    }

    public async testUpload(payload: Array<File>, config?: RequestConfig): Promise<any> {


        return new Promise(resolve => setTimeout(function () {
            let data = [];
            for(const i in payload) {
                data.push({name: "Name"});
            }
            resolve(data)}, 3000));
    }

    // public uploadMusic(payload: FileRequest, config?: RequestConfig): Promise<FileAudioResponse> {
    //     return this.fileRepository.uploadAudio(payload, config);
    // }
}
